/**
 * Get the editor link with the project ID and branch, if set.
 *
 * If the user is already on the editor page maintain the settings they have selected and set or remove the branch, if
 * required to do so.
 */
export const getEditorLink = (projectId: string, branchName?: string): string => {
    const editorLink = `/project/${projectId}`;
    const usersCurrentLocation = window.location.href;
    const currentUrl = new URL(usersCurrentLocation);

    if (!currentUrl.pathname.startsWith(editorLink)) {
        return branchName ? `${editorLink}/?view=multi&branch=${branchName}` : `${editorLink}/?view=multi`;
    }

    if (branchName) {
        currentUrl.searchParams.set('branch', branchName);
    } else {
        currentUrl.searchParams.delete('branch');
    }

    return currentUrl.toString();
};

export default getEditorLink;
